import { DialogProps, Layout } from "@mcleod/components";
import { CommonDialogs } from "@mcleod/common";
import { DemoDefinition } from "../DemoDefinition";
import { DemoRegistry } from "../DemoRegistry";

export class DemoMovableResizableModalDialog extends Layout {
    buttonTryItMovableOnClick() {
        CommonDialogs.showDialog("This dialog can be moved around the screen.");
    }

    buttonTryItNotMovableOnClick() {
        const dialogProps: Partial<DialogProps> = { movable: false };
        CommonDialogs.showDialog("This dialog cannot be moved around the screen.", dialogProps);
    }

    buttonTryItNotResizableOnClick() {
        CommonDialogs.showDialog("This dialog cannot be resized.");
    }

    buttonTryItResizableOnClick() {
        const dialogProps: Partial<DialogProps> = { resizable: true };
        CommonDialogs.showDialog("This dialog can be resized.", dialogProps);
    }

    buttonTryItModalOnClick() {
        const message = "This dialog is modal; the user is not allowed to interact with other parts of the page" +
            " until the dialog has been closed.";
        CommonDialogs.showDialog(message);
    }

    buttonTryItNotModalOnClick() {
        const dialogProps: Partial<DialogProps> = { modal: false };
        const message = "This dialog is not modal; the user is allowed to interact with other parts of the page.";
        CommonDialogs.showDialog(message, dialogProps);
    }
}
DemoRegistry.get().register(new DemoDefinition("dialogs/DemoMovableResizableModalDialog", [ "Dialogs", "Movable/Resizable/Modal" ]));
